import React, { useEffect, useState } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import { readUserApi } from '@/lib/api/Users';

const RedirectIfAuthenticated = () => {
    const navigate = useNavigate();
    const [checking, setChecking] = useState(true);

    useEffect(() => {
        const checkUserToken = async () => {
            const token = localStorage.getItem('authToken');

            if (!token) {
                setChecking(false); // no token, allow access to public pages
                return;
            }

            try {
                const user = await readUserApi(token);

                // redirect based on role
                if (user.is_admin) {
                    navigate('/admin', { replace: true });
                } else if (user.account_type === 'sport_participant') {
                    navigate('/participant', { replace: true });
                } else if (user.account_type === 'sport_organizer') {
                    navigate('/organizer', { replace: true });
                } else {
                    setChecking(false);
                }
            } catch (err) {
                console.error('Invalid token:', err);
                setChecking(false);
            }
        };

        checkUserToken();
    }, [navigate]);

    if (checking) return null; // optional spinner while checking

    return <Outlet />; // render nested public routes
};

export default RedirectIfAuthenticated;
